// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/bootstrap.min.css";
//import "./styles/bootstrap.purged.css";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter as Router } from "react-router-dom";
import { ROUTER_BASENAME } from './Config.js';

import { MaintenanceModeProvider } from "./contexts/MaintenanceModeContext";

// 🔹 Componente para carregar Google Tag Manager corretamente
const GoogleTagManager = () => {
  React.useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=G-FXP52ZHFNJ`;

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      window.gtag("js", new Date());
      window.gtag("config", "G-FXP52ZHFNJ");
      console.log("gtag carregado e inicializado");
    };

    document.head.appendChild(script);
  }, []);

  return null; // Não renderiza nada na tela
};

// 🔹 Criando a raiz do React
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router basename={ROUTER_BASENAME}>
      <MaintenanceModeProvider>
        <App />
      </MaintenanceModeProvider>
      <GoogleTagManager /> {/* Adicionando GTM dentro do App */}
    </Router>
  </React.StrictMode>
);

// 🔹 Carregar Bootstrap JS de forma assíncrona para evitar bloqueios
const bootstrapScript = document.createElement("script");
bootstrapScript.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.bundle.min.js";
bootstrapScript.integrity = "sha384-ENjdO4Dr2bkBIFxQpeoTz1HIcje39Wm4jDKdf19U8gI4ddQ3GYNS7NTKfAdVQSZe";
bootstrapScript.crossOrigin = "anonymous";
bootstrapScript.defer = true;
document.head.appendChild(bootstrapScript);

// 🔹 Carregar Bootstrap Icons sem bloquear renderização
const iconsLink = document.createElement("link");
iconsLink.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css";
iconsLink.rel = "stylesheet";
iconsLink.onload = () => { console.log("Bootstrap Icons carregado"); };
document.head.appendChild(iconsLink);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// 🔹 Adiar o carregamento do reportWebVitals para priorizar a renderização
setTimeout(() => reportWebVitals(), 2000);